import { Link } from 'react-router';

/** Port of footer.component.html, text preserved verbatim. */
export function Footer() {
  return (
    <footer className="border-t border-header-line bg-header px-4 py-5 text-sm text-on-header-muted">
      <div className="mx-auto grid max-w-7xl gap-4 md:grid-cols-2">
        <p className="md:col-span-2">
          <strong className="font-semibold">Transaction Data Disclaimer:</strong> Transaction
          information is provided on an &ldquo;AS IS&rdquo; and &ldquo;AS AVAILABLE&rdquo; basis,
          may be preliminary, delayed, or subject to reconciliation, and does not constitute
          official books and records. Official records control. Use of and reliance on this
          information is subject to the Website Terms of Use.
        </p>

        <p>
          <strong className="font-semibold">Confidential:</strong> Access is restricted to
          authorized users. Information may be confidential and may not be disclosed without
          authorization. This Site may be monitored.
        </p>

        <p className="font-semibold">
          Information provided on this Site is for informational purposes only and does not
          constitute investment, legal, or tax advice.
        </p>

        <p className="flex flex-wrap items-center gap-2">
          <Link to="/disclaimers#termsOfUse" className="underline hover:text-on-header">
            Website Terms of Use
          </Link>
          <span aria-hidden="true">|</span>
          <Link to="/disclaimers#privacyNotice" className="underline hover:text-on-header">
            Privacy Notice
          </Link>
        </p>

        <p className="font-semibold">&copy; 2026 Tertius Group, LLC. All rights reserved.</p>
      </div>
    </footer>
  );
}
